export default __webpack_public_path__ + "static/media/back_icon.7541eb88.svg";